/* eslint-disable no-unused-vars */
import { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Virtuoso } from 'react-virtuoso';
import { Africa, Asia, Europe, NorthAmerica, Oceania, SouthAmerica } from 'constants';
import { ItemContent } from './ItemContent';
import { searchLocationsCitysAPI } from 'services/searchLocationsCitysAPI.service';
import { useToggleState } from './useToggleState';
import { Loader } from 'components';
import { useSet } from 'utils';
import { useFacade } from './useFacade';
import * as S from './ChooseContent.styled';

const goToParent = (itemId, resType) => {
  let amountOfUnderscores = 0;
  for (const it of itemId) {
    if (it === '_') {
      amountOfUnderscores++;
    }
  }
  if (amountOfUnderscores !== 3) {
    throw new Error('amountOfUnderscores is not 3');
  }
  const [continent, country = '', region = '', city = ''] = itemId.split('_');
  if (resType === 'continent') {
    return `${continent}___`;
  }
  if (resType === 'country') {
    return `${continent}_${country}__`;
  }
  if (resType === 'region') {
    return `${continent}_${country}_${region}_`;
  }
};

const toggleSet = (element) => (set) => {
  if (set.has(element)) {
    return set.delete(element);
  }
  set.add(element);
};

export const ChooseContent = ({
  includeSet,
  excludeSet,
  setIncludeSet,
  setExcludeSet,
  isActiveItem,
  childrenIsExcluded,
  toggleCheckedCountryOrRegion,
}) => {
  const { data, isSuccess, isError, isLoading } =
    searchLocationsCitysAPI.useGetInitLocationsListQuery();

  const { uniqueIdToItemMap } = useFacade(data);

  const {
    toggle: toggleContinent,
    isActive: isOpenedContinent,
    state: openedContinents,
  } = useToggleState();

  const {
    toggle: toggleCountry,
    isActive: isOpenedCountry,
    state: openedCountries,
  } = useToggleState();

  if (isLoading)
    return (
      <div>
        <Loader.Local delay={100} />
      </div>
    );

  if (data)
    return (
      <S.MyVirtuoso
        data={data}
        itemContent={(index, item) => (
          <ItemContent
            index={index}
            item={item}
            toggleContinent={toggleContinent}
            isOpenedContinent={isOpenedContinent}
            toggleCountry={toggleCountry}
            isOpenedCountry={isOpenedCountry}
            isActiveItem={isActiveItem}
            toggleCheckedCountryOrRegion={toggleCheckedCountryOrRegion}
            childrenIsExcluded={childrenIsExcluded}
          />
        )}
      />
    );
};
